module.exports = __webpack_public_path__ + "img/circle.4fd71148.gif";